import { array, number, partial } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

export const Request = iotsUtils.withDefault(
	partial({
		pageNumbers: array(number),
	}),
	{}
);
